/**
 * Filters a list of routes for the ones that belong in the navbar.
 *
 * @param {any} routes The routes to filter.
 * @returns A list of routes that belong in the navbar.
 */
function navBarRoutesFromRoutes (routes) {
  return routes.filter(route => {
    const isNavBarRoute = route.meta && route.meta.navbar
    return isNavBarRoute
  })
}

/**
 * Filters a list of routes for the ones that belong in the dashboard.
 *
 * @param {any} routes The routes to filter.
 * @returns A list of routes that belong in the dashboard.
 */
function dashboardRoutesFromRoutes (routes) {
  return routes.filter(route => {
    const isDashboardRoute = route.meta && route.meta.dash
    return isDashboardRoute
  })
}

/**
 * Filters a list of routes for the ones that require authentication.
 *
 * @param {any} routes The routes to filter.
 * @param {bool} isAuthenticated The authentication state to filter for.
 * @returns A list of routes that require authentication to access.
 */
function authenticatedRoutesFromRoutes (routes, isAuthenticated) {
  return routes.filter(route => {
    const isAuthRoute = route.meta && route.meta.auth
    const isAuthenticatedAndRouteRequiresAuth = isAuthenticated || !isAuthRoute
    return isAuthenticatedAndRouteRequiresAuth
  })
}

/**
 * Filters a list of routes for the ones that are publicly accessible, without authentication.
 *
 * @param {any} routes The routes to filter.
 * @returns A list of routes that do not require authentication to access.
 */
function publicRoutesFromRoutes (routes) {
  return routes.filter(route => {
    if (route.meta) {
      return route.meta.auth === false
    }
    return false
  })
}
/**
 * Determines if a user can access a route.
 * @param {Object} route The route to filter.
 * @param {Object} entitlements The entitlements that the user has.
 */
function canAccessRoute (route, entitlements) {
  if (!entitlements || !Object.keys(entitlements).length) {
    return !route.meta.service // If there is a service, filter, otherwise, pass through.
  }

  if (!route.meta || !route.meta.service) {
    return true
  }

  const serviceEnabled = !!entitlements[route.meta.service]
  if (!route.meta.operation || !serviceEnabled) {
    return serviceEnabled
  }

  return entitlements[route.meta.service].includes(route.meta.operation)
}

/**
 * Returns routes that the user can access, given a set of routes, and a set of entitlements.
 * @param {*} routes The routes to filter.
 * @param {*} entitlements An entitlements dictionary.
 */
function routesForEntitlements (routes, entitlements) {
  return routes.filter(route => {
    return canAccessRoute(route, entitlements)
  })
}

/**
 * Filters a list of routes for staff tools list.
 * @param {Boolean} isStaff Tells the filter if the user is staff or not.
 * @param {Array} routes A list of routes.
 * @return A list of routes for the staff tools menu.
 */
function staffRoutesFromRoutes (routes, isStaff) {
  return routes.filter(route => route.meta && route.meta.staff && isStaff)
}

/**
 * Filters a list of routes for the staff tools menu.
 * Does not check if the user meets access requirements.
 *
 * @param {Array} routes The routes to filter.
 */
function adminRoutesFromRoutes (routes) {
  return routes.filter(route => route.meta && route.meta.staff)
}

export { navBarRoutesFromRoutes, dashboardRoutesFromRoutes, authenticatedRoutesFromRoutes, publicRoutesFromRoutes, routesForEntitlements, staffRoutesFromRoutes, adminRoutesFromRoutes }
